import Component from '@glimmer/component';
import { localCopy } from 'tracked-toolbox';

interface MessageBoxSignature {
  Args: {
    type?: 'info' | 'warning' | 'error' | 'success' | 'attention';
    header?: string;
  };
  Blocks: {
    default: [];
  };
  Element: HTMLDivElement;
}

export default class MessageBox extends Component<MessageBoxSignature> {
  @localCopy('args.type', 'info') declare type: this['args']['type'];

  <template>
    {{! Message boxes can have an optional header. }}
    <div class="text-sm messageBox pt-4 pb-4 pr-4 pl-12 {{this.type}}" ...attributes>
      {{#if @header}}
        <h2 class="text-sm lh-15">{{@header}}</h2>
      {{/if}}

      {{yield}}
    </div>
  </template>
}
